import en from './en'
import ko from './ko'
import ms from './ms'
import th from './th'
import vi from './vi'
// import zh from './zh'
import _in from './in'
// ko韩语 zh中文繁体 en英语 in印尼  th泰语 vi越南语 ms 马来语
export default { en, ko, ms, th, vi, in: _in }
